export default __webpack_public_path__ + "static/media/image1.b9ddc422.jpg";